<script>
export default {
  props: {
    component: Object,
    handler: Object,
  },
  mounted() {
    if (this.handler && !this.component.read)
      this.handler.action(this.component, "read", []);

    this.$emit('mounted', this.$el);
  },
};
</script>

<template>
  <f-button type="secondary" :href="component.data.link" blank
    >{{ component.data.label }}<f-icon :icon="component.data.icon"></f-icon
  ></f-button>
</template>

<style lang="scss" scoped>
.f-button {
  margin: 10px;
  align-self: center;

  .f-icon {
    font-size: 20px;
  }
}
</style>